import {
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  Dialog,
  DialogContent,
} from "@mui/material";
import Webcam from "react-webcam";
import LocalSeeIcon from "@mui/icons-material/LocalSee";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddIcon from "@mui/icons-material/Add";
import { ExpandMore, KeyboardArrowRight } from "@mui/icons-material";
import React, { useEffect, useRef, useState } from "react";
import { useTheme } from "../../../../components/hooks/useTheme";
import { useNavigate } from "react-router-dom";
import baseURL from "../../../../configs/api";
import axios from 'axios';
import Select from "react-select";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import { getAdditionalCharges } from "../../../../services/additionalCharge";
import { post_VehicleClassFeatureMapping } from "../../../../services/vehicleClassFeatureMapping";
import { EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import useGeneral from "../../../../components/hooks/useGeneral";
import { handleCapture } from "../../../../utils/covertTheBase64FormatIntoImage";
import colorConfigs from "../../../../configs/colorConfigs";
import { validateMin } from "../../../../utils/validateMin";
import CustomFormatDatePicker from "../../../../components/common/CustomFormatDatePicker";
import useDelete from "../../../../components/hooks/useDelete";
import useConfirm from "../../../../components/hooks/useConfirm";
import useAuth from "../../../../components/hooks/useAuth";
import { CustomImagePopup } from "../../../../components/common/CustomImagePopup";
import { fuelTypesOption } from "../../../../utils/fuelTypesOption";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";


export const AddVehicleClass = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { themeStyles, theme } = useTheme();
  const navigate = useNavigate();
  const { dateFormat }: any = useGeneral();
  const { setDeletePopup, setData: setDeleteData }: any = useDelete();
  const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
  const [isGeneralSettings, setIsGeneralSettings] = useState<boolean>(true);
  const [isRentalProcess, setIsRentalProcess] = useState<boolean>(true);
  const [isAdvanced, setIsAdvanced] = useState<boolean>(true);
  const [isWebsite, setIsWebsite] = useState<boolean>(true);
  const [branch, setBranch] = useState([]);
  const [name, setName] = useState<string>("");
  const [branchId, setBranchId] = useState<string>("");
  const [availableOnWebsite, setAvailableOnWebsite] = useState<string>("No");
  const [active, setActive] = useState<string>("No");
  const [order, setOrder] = useState<string>("");
  const [calenderOrder, setCalenderOrder] = useState<string>("");
  const [allowedOverbookingQuantity, setAllowedOverbookingQuantity] =
    useState<string>("");
  const [overbookingBackupClassId, setOverbookingBackupClassId] =
    useState<string>("");
  const [minimumRentalAllowedAge, setMinimumRentalAllowedAge] =
    useState<string>("");
  const [maxRentalAllowedAge, setMaxRentalAllowedAge] = useState<string>("");
  const [tankSize, setTankSize] = useState<string>("");
  const [allEngineTypes, setAllEngineTypes] = useState<any[]>([]);
  const [engineType, setEngineType] = useState<string>("");
  const [vehicleHeight, setVehicleHeight] = useState<string>("");
  const [fuel, setFuel] = useState<string>(fuelTypesOption[0]?.value);
  const [fuelChargeperOneByEight, setFuelChargeperOneByEight] =
    useState<string>("");
  const [allowedRoles, setAllowedRoles] = useState<string>("");
  const [allowedLocations, setAllowedLocations] = useState<string>("");
  const [restrictedLocations, setRestrictedLocations] = useState<string>("");
  const [startDate, setStartDate] = useState<string>("");
  const [spareQuantity, setSpareQuantity] = useState<string>("");
  const [distancelimit, setDistancelimit] = useState<string>("");
  const [distanceLimitperDay, setDistanceLimitperDay] = useState<string>("");
  const [distanceLimitperWeek, setDistanceLimitperWeek] = useState<string>("");
  const [distanceLimitperMonth, setDistanceLimitperMonth] =
    useState<string>("");
  const [additionalChargeOptions, setAdditionalChargeOptions] = useState<any[]>([]);
  const [
    additionalChargeIdforExceededDistance,
    setAdditionalChargeIdforExceededDistance,
  ] = useState<string>("");
  const [
    additionalChargeIdforReturnInDifferentLocation,
    setAdditionalChargeIdforReturnInDifferentLocation,
  ] = useState<string>("");
  const [additionalChargeIdForAdditionalDriver, setAdditionalChargeIdForAdditionalDriver] = useState<string>("");
  const [sipp, setSipp] = useState<string>("");
  const [driverYearsExperience, setDriverYearsExperience] =
    useState<string>("");
  const [enableFuelLevelTracking, setEnableFuelLevelTracking] = useState<string>("No");
  const [enableOdometerTracking, setEnableOdometerTracking] = useState<string>("No");
  const [similarVehicleMakeId, setSimilarVehicleMakeId] = useState<string>("");
  const [similarVehicleModelId, setSimilarVehicleModelId] =
    useState<string>("");
  const [features, setFeatures] = useState<any>();
  const [featuresOptions, setFeaturesOptions] = useState<any[]>([]);
  const [label, setLabel] = useState<string>("");
  const [shortDiscription, setShortDiscription] = useState<string>("");
  const [discription, setDiscription] = useState<string>("");

  const [recommended, setRecommended] = useState<string>("No");
  const [limitedAvailability, setLimitedAvailability] = useState<string>("No");
  const [
    percentageforLimitedAvailability,
    setPercentageForLimitedAvailability,
  ] = useState<string>("");

  const [showWebcam, setShowWebcam] = useState<boolean>(false);
  const [filePath, setFilePath] = useState<string>("");
  const [file, setFile] = useState<FileList | null>(null);
  const [imagePopup, setImagePopup] = useState<boolean>(false);
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
  const [minAgeError, setMinAgeError] = useState("");
  const [maxAgeError, setMaxAgeError] = useState("");
  const [websiteShowWebcam, setWebsiteShowWebcam] = useState<boolean>(false);
  const [websiteFilePath, setWebsiteFilePath] = useState<any[]>([]);
  const [fileIndex, setFileIndex] = useState<number>(-1);
  const [websiteImagePopup, setWebsiteImagePopup] = useState<boolean>(false);


  const inputWebsiteFileRef = useRef<HTMLInputElement>(null);
  const onWebsiteFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPleaseWaitPopup(true);
    const selectedFiles = e.target.files as FileList;

    if (selectedFiles && selectedFiles.length > 0) {
      const file = selectedFiles[0];
      const fileName = file.name.toLowerCase();

      const supportedExtensions = ['.jpg', '.jpeg', '.png', '.heif'];

      const isSupported = supportedExtensions.some(ext => fileName.endsWith(ext));

      if (isSupported) {
        const formData = new FormData();
        formData.append("ImageFile", selectedFiles[0]);

        axios
          .post(`${baseURL}vehicleClassFile/upload`, formData, {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "multipart/form-data"
            },
            withCredentials: true,
          })
          .then((response) => {
            const file: any = {
              id: 0,
              fileName: `${baseURL}vehicleClassFile/Get?name=${response.data}`
            };
            setWebsiteFilePath(prevPath => [...prevPath, file]);
            setPleaseWaitPopup(false);
            handleTenantError(null);
          })
          .catch((error) => {
            handleTenantError(error);
          });
      } else {
        setPleaseWaitPopup(false);
        console.error('Unsupported file type');

        setConfirmData({
          title: 'Warning',
          summary: "Unsupported file type",
          confirmBtn: 'Ok',
          isConfirm: (callback: any) => {
            callback();
          }
        });

        setConfirmPopup(true);
      }
    }
  };

  useEffect(() => {
    axios
      .get(`${baseURL}vehicleEngine`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setAllEngineTypes(() =>
          response.data.map((item: any) => {
            return {
              value: item.id,
              label: item.engineName
            };
          })
        );
        setEngineType(response.data[0]?.id)
        handleTenantError(null);
      }).catch((error) => {
        handleTenantError(error);
      })

       // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const timeout = setTimeout(() => {
      const min = Number(minimumRentalAllowedAge);
      const max = Number(maxRentalAllowedAge);

      if (minimumRentalAllowedAge !== "" && maxRentalAllowedAge !== "") {
        if (min > max) {
          setMinAgeError("Minimum age cannot be greater than maximum age.");
          setMaxAgeError("Maximum age cannot be less than minimum age.");
        } else {
          setMinAgeError("");
          setMaxAgeError("");
        }
      } else {
        setMinAgeError("");
        setMaxAgeError("");
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [minimumRentalAllowedAge, maxRentalAllowedAge]);

  useEffect(() => {
    axios
      .get(`${baseURL}branch`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setBranch(() =>
          response?.data.map((item: any) => {
            return { value: item.id, label: item.branchName };
          })
        );

        setBranchId(response.data[0]?.id);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    axios
      .get(`${baseURL}Feature`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setFeaturesOptions(() =>
          response.data.map((item: any) => {
            return {
              value: item.id,
              label: item.label
            };
          })
        );

        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getAdditionalCharges(tenantId)
      .then((res) => {
        setAdditionalChargeOptions(
          res.filter((value: any) => !value.hideFromReservations)
            .map((item: any) => {
              return {
                value: item?.id,
                label: item?.name
              }
            })
        )
        handleTenantError(null);
      })
      .catch((error) => handleTenantError(error))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!!minAgeError || !!maxAgeError) return;

    if (pleaseWaitPopup) return;

    setPleaseWaitPopup(true);

    if (filePath === "" && (file === null || file.length === 0)) {
      setConfirmData({
        title: 'Warning',
        summary: "Please add an image.",
        confirmBtn: 'Ok',
        isConfirm: (callback: any) => {
          callback();
        }
      });

      setConfirmPopup(true);

      setPleaseWaitPopup(false);
      return;
    }

    if (filePath !== "") {
      saveVehicleClass(filePath?.replace(`${baseURL}vehicleClassFile/Get?name=`, ""));
    } else {
      if (file && file.length > 0) {
        const formData = new FormData();
        formData.append("ImageFile", file[0]);

        try {
          const response = await axios.post(`${baseURL}vehicleClassFile/upload`, formData, {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "multipart/form-data"
            },
            withCredentials: true,
          });
          saveVehicleClass(response.data);
          handleTenantError(null);
        } catch (error) {
          handleTenantError(error);

          setConfirmData({
            title: 'Warning',
            summary: "An error occurred while uploading the image. Please try again.",
            confirmBtn: 'Ok',
            isConfirm: (callback: any) => {
              callback();
            }
          });

          setConfirmPopup(true);

          setPleaseWaitPopup(false);
        }
      } else {
        setConfirmData({
          title: 'Warning',
          summary: "An error occurred while uploading the image. Please try again.",
          confirmBtn: 'Ok',
          isConfirm: (callback: any) => {
            callback();
          }
        });

        setConfirmPopup(true);

        setPleaseWaitPopup(false);
      }
    }
  };

  const saveVehicleClass = (fileName: string) => {
    axios
      .post(
        `${baseURL}vehicleClass?userId=${auth?.id}`,
        JSON.stringify({
          name,
          branchId,
          imagePath: fileName,
          availableOnWebsite: availableOnWebsite === "Yes",
          active: active === "Yes",
          recommended: recommended === "Yes",
          order,
          calenderOrder,
          allowedOverbookingQuantity,
          overbookingBackupClassId,
          minimumRentalAllowedAge,
          maxRentalAllowedAge,
          tankSize,
          limitedAvailability: limitedAvailability === "Yes",
          percentageforLimitedAvailability,
          fuelChargeperOneByEight,
          allowedRoles,
          allowedLocations,
          restrictedLocations,
          startDate: startDate + "T00:00:00",
          spareQuantity,
          distancelimit,
          distanceLimitperDay,
          distanceLimitperWeek,
          distanceLimitperMonth,
          additionalChargeIdforExceededDistance,
          additionalChargeIdforReturnInDifferentLocation,
          additionalChargeIdForAdditionalDriver,
          sipp,
          driverYearsExperience,
          enableFuelLevelTracking: enableFuelLevelTracking === "Yes",
          enableOdometerTracking: enableOdometerTracking === "Yes",
          similarVehicleMakeId,
          similarVehicleModelId,
          features: "",
          label,
          shortDiscription,
          discription,
          engineType,
          vehicleHeight,
          fuel
        }),
        {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
          },
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res?.data) {
          if (features?.length > 0) {
            post_VehicleClassFeatureMapping(
              features?.map((item: any) =>
              ({
                vehicleClassId: res?.data,
                featureId: item?.value
              })
              ), auth?.id, tenantId)
              .then(() => {
                saveWebsiteFile(res?.data);
              })
              .catch(error => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
              })
          } else {
            saveWebsiteFile(res?.data);
          }
        } else {
          setPleaseWaitPopup(false);
        }
        handleTenantError(null);
      })
      .catch(error => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });
  }

  const saveWebsiteFile = (id: number) => {
    if (websiteFilePath?.length > 0) {
      let count = 0;
      websiteFilePath
        ?.forEach(async (item: any, _: number, arr: any[]) => {
          await axios
            .post(
              `${baseURL}fileUploadData?userId=${auth?.id}`,
              JSON.stringify({
                attributeName: "VehicleClass",
                attributeId: id,
                fileName: item.fileName?.replace(`${baseURL}vehicleClassFile/Get?name=`, ""),
                tabName: "VehicleClass",
                userId: auth?.id,
                createdDate: new Date(),
              }),
              {
                headers: {
                  'X-Tenant-ID': tenantId,
                  "Content-Type": "application/json"
                },
                withCredentials: true,
              }
            )
            .then(() => {
              count++;
              if (arr.length === count) {
                setPleaseWaitPopup(false);
                navigate(-1);
              }
              handleTenantError(null);
            })
            .catch(error => handleTenantError(error));
        });
    } else {
      setPleaseWaitPopup(false);
      navigate(-1);
    }
  }

  const webRef = useRef(null);
  const inputFileRef = useRef<HTMLInputElement>(null);
  const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
    /*Selected files data can be collected here.*/
    const selectedFiles = e.target.files as FileList;

    if (selectedFiles && selectedFiles.length > 0) {
      const file = selectedFiles[0];
      const fileName = file.name.toLowerCase();

      const supportedExtensions = ['.jpg', '.jpeg', '.png', '.heif'];

      const isSupported = supportedExtensions.some(ext => fileName.endsWith(ext));

      if (isSupported) {
        setFilePath("");
        setFile(selectedFiles);
      } else {
        console.error('Unsupported file type');
        setConfirmData({
          title: 'Warning',
          summary: "Unsupported file type",
          confirmBtn: 'Ok',
          isConfirm: (callback: any) => {
            callback();
          }
        });

        setConfirmPopup(true);
      }
    }
  };

  const [editorStateShort, setEditorStateShort] = useState(() =>
    EditorState.createEmpty()
  );
  const [editorStateDescription, setEditorStateDescription] = useState(() =>
    EditorState.createEmpty()
  );

  useEffect(() => {
    setShortDiscription(
      draftToHtml(convertToRaw(editorStateShort.getCurrentContent()))
    );
  }, [editorStateShort]);

  useEffect(() => {
    setDiscription(
      draftToHtml(convertToRaw(editorStateDescription.getCurrentContent()))
    );
  }, [editorStateDescription]);

  const handleDeleteImage = () => {
    setDeleteData({
      id: 0,
      tilte: `Delete`,
      summary: `Are you sure you want to delete this Image?`,
      isDelete: async (callback: any) => {
        if (inputFileRef.current) {
          inputFileRef.current.value = '';
        }
        setFile(null);
        setFilePath("");

        callback();
      }
    });

    setDeletePopup(true);
  }

  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full mt-2">
            <div className={`w-full pb-4`}>

              <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                <div className="flex items-center gap-1.5">
                  <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Add Vehicle Class</h2>
                </div>
              </div>

              <div className="w-3/4 mt-2 p-2">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <h5
                    className="mb-0 flex items-center cursor-pointer select-none"
                    onClick={() => setIsGeneralSettings(!isGeneralSettings)}
                  >
                    {isGeneralSettings ? (
                      <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                    ) : (
                      <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                    )}
                    <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                      General
                    </div>
                  </h5>
                  <hr />

                  <div className="w-full px-2 mt-1.5">
                    {isGeneralSettings &&
                      <div className="grid grid-cols-2 gap-6">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Name</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                              required
                            />
                          </div>

                          <div className="mt-2">
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Images</label>
                            {(file || filePath) && (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                {file && (
                                  <img
                                    src={URL.createObjectURL(file[0])}
                                    width={40}
                                    height={40}
                                    alt="vehicle"
                                    onClick={() => setImagePopup(true)}
                                  />
                                )}

                                {filePath && (
                                  <img
                                    src={filePath}
                                    width={40}
                                    height={40}
                                    alt="vehicle"
                                    onClick={() => setImagePopup(true)}
                                  />
                                )}

                                <RemoveCircleIcon
                                  sx={{
                                    fontSize: "14px",
                                    color: colorConfigs.topbar.bg,
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                    "&: hover": {
                                      color: "red",
                                    },
                                  }}
                                  onClick={handleDeleteImage}
                                />
                              </div>
                            )}
                            <input
                              type="file"
                              accept="image/*"
                              ref={inputFileRef}
                              onChangeCapture={onFileChangeCapture}
                              style={{ display: "none" }}
                            />
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "8px",
                                marginTop: "8px",
                              }}
                            >
                              <p
                                style={{
                                  border: "1px dashed black",
                                  borderRadius: "3px",
                                  padding: "3px 5px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  fontSize: "12px",
                                  backgroundColor: "white",
                                  cursor: "pointer"
                                }}
                                onClick={(e) => {
                                  if (inputFileRef.current) {
                                    inputFileRef.current.value = ""
                                  }
                                  inputFileRef.current?.click();
                                }}
                              >
                                {" "}
                                <AddIcon className="text-[#167AC3] text-[14px] font-bold" />
                                Add Image
                              </p>

                              <p
                                style={{
                                  border: "1px dashed black",
                                  borderRadius: "3px",
                                  padding: "3px 5px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  fontSize: "12px",
                                  backgroundColor: "white",
                                  cursor: "pointer"
                                }}
                                onClick={() => setShowWebcam(true)}>
                                {" "}
                                <LocalSeeIcon className="text-[#167AC3] text-[14px] font-bold" />
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Branch</label>
                            <select
                              className={`w-full px-[8px] py-[10px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={branchId}
                              onChange={(e) => setBranchId(e.target.value)}
                            >
                              {branch?.map((role: any, index: number) => (
                                <option key={index} value={role.value}>
                                  {role.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    }

                    <h5
                      className="mb-0 mt-4 flex items-center cursor-pointer select-none"
                      onClick={() => setIsRentalProcess(!isRentalProcess)}
                    >
                      {isRentalProcess ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}
                      <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                        Rental Process
                      </div>
                    </h5>
                    <hr />

                    {isRentalProcess &&
                      <div className="grid grid-cols-2 gap-6 mt-2">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Available on Website?</label>
                            <RadioGroup
                              row
                              value={availableOnWebsite}
                              onChange={(e) => setAvailableOnWebsite(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "blue",
                                    },
                                  }}
                                />} label="Yes"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "blue",
                                    },
                                  }}
                                />} label="No"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                            </RadioGroup>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Recommended?</label>
                            <RadioGroup
                              row
                              value={recommended}
                              onChange={(e) => setRecommended(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "blue",
                                    },
                                  }}
                                />} label="Yes"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "blue",
                                    },
                                  }}
                                />} label="No"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                            </RadioGroup>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Order</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={order}
                              onChange={(e) => setOrder(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Allowed Overbooking Quantity</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={allowedOverbookingQuantity}
                              onChange={(e) =>
                                setAllowedOverbookingQuantity(validateMin(e.target.value, 0).toString())
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Minimum Rental Allowed Age</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={minimumRentalAllowedAge}
                              onChange={(e) =>
                                setMinimumRentalAllowedAge(e.target.value)
                              }
                              required
                            />
                            {minAgeError && <p className="text-red-500 text-sm mt-1">{minAgeError}</p>}
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Tank Size {`(Gallon/Liter)`}</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={tankSize}
                              onChange={(e) => setTankSize(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Engine Type</label>
                            <select
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={engineType}
                              onChange={(e) => setEngineType(e.target.value)}
                              required
                            >
                              {
                                allEngineTypes?.map((item: any, index: number) => (
                                  <option key={index} className={`${themeStyles.main.tailwindSectionBg}`} value={item.value}>{item.label}</option>
                                ))
                              }

                            </select>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Fuel</label>
                            <select
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={fuel}
                              onChange={(e) => setFuel(e.target.value)}
                              required
                            >
                              {
                                fuelTypesOption.map((item: any, index: number) => (
                                  <option className={`${themeStyles.main.tailwindSectionBg}`} value={item.value}>{item.label}</option>
                                ))
                              }

                            </select>
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Active?</label>
                            <RadioGroup
                              row
                              value={active}
                              onChange={(e) => setActive(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "blue",
                                    },
                                  }}
                                />} label="Yes"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "blue",
                                    },
                                  }}
                                />} label="No"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                            </RadioGroup>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Limited Availability</label>
                            <RadioGroup
                              row
                              value={limitedAvailability}
                              onChange={(e) => setLimitedAvailability(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "blue",
                                    },
                                  }}
                                />} label="Yes"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "blue",
                                    },
                                  }}
                                />} label="No"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                            </RadioGroup>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Calendar Order</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={calenderOrder}
                              onChange={(e) => setCalenderOrder(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Overbooking Backup Class</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={overbookingBackupClassId}
                              onChange={(e) =>
                                setOverbookingBackupClassId(validateMin(e.target.value, 0).toString())
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Maximum Rental Allowed Age</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={maxRentalAllowedAge}
                              onChange={(e) => setMaxRentalAllowedAge(validateMin(e.target.value, 0).toString())}
                              required
                            />
                            {maxAgeError && <p className="text-red-500 text-sm mt-1">{maxAgeError}</p>}
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Fuel Charge per 1/8</label>
                            <input
                              type="number"
                              min={0}
                              step={0.01}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={fuelChargeperOneByEight}
                              onChange={(e) =>
                                setFuelChargeperOneByEight(validateMin(e.target.value, 0).toString())
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Percentage for Limited Availability</label>
                            <input
                              type="number"
                              min={0}
                              step={0.01}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={percentageforLimitedAvailability}
                              onChange={(e) =>
                                setPercentageForLimitedAvailability(validateMin(e.target.value, 0).toString())
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Vehicle Height</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={vehicleHeight}
                              onChange={(e) =>
                                setVehicleHeight(e.target.value)
                              }
                              required
                            />
                          </div>
                        </div>
                      </div>
                    }

                    <h5
                      className="mb-0 mt-4 flex items-center cursor-pointer select-none"
                      onClick={() => setIsAdvanced(!isAdvanced)}
                    >
                      {isAdvanced ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}
                      <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                        Advanced
                      </div>
                    </h5>
                    <hr />

                    {isAdvanced &&
                      <div className="grid grid-cols-2 gap-6 mt-2">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Allowed Roles</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={allowedRoles}
                              onChange={(e) =>
                                setAllowedRoles(e.target.value)
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Allowed Locations</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={allowedLocations}
                              onChange={(e) =>
                                setAllowedLocations(e.target.value)
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Start Date</label>
                            <CustomFormatDatePicker
                              value={startDate}
                              onChange={setStartDate}
                              dateFormat={dateFormat}
                              required={true}
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Distance Limit per Hour</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={distancelimit}
                              onChange={(e) => setDistancelimit(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Distance Limit per Day</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={distanceLimitperDay}
                              onChange={(e) => setDistanceLimitperDay(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Distance Limit per Month</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={distanceLimitperMonth}
                              onChange={(e) =>
                                setDistanceLimitperMonth(validateMin(e.target.value, 0).toString())
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>SIPP Code</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={sipp}
                              onChange={(e) => setSipp(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Driver Years Experience</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={driverYearsExperience}
                              onChange={(e) =>
                                setDriverYearsExperience(validateMin(e.target.value, 0).toString())
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Enable Fuel Level Tracking</label>
                            <RadioGroup
                              row
                              value={enableFuelLevelTracking}
                              onChange={(e) => setEnableFuelLevelTracking(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "blue",
                                    },
                                  }}
                                />} label="Yes"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "blue",
                                    },
                                  }}
                                />} label="No"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                            </RadioGroup>
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium invisible ${themeStyles.form.tailwindLabelTextColor}`}>Allowed Roles</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md invisible ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Restricted Locations</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={restrictedLocations}
                              onChange={(e) =>
                                setRestrictedLocations(e.target.value)
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Spare Quantity</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={spareQuantity}
                              onChange={(e) => setSpareQuantity(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Distance Limit per Week</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={distanceLimitperWeek}
                              onChange={(e) =>
                                setDistanceLimitperWeek(validateMin(e.target.value, 0).toString())
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Additional Charge for Exceeded Distance</label>
                            <Select
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                  borderRadius: '8px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                  "&: hover": {
                                    borderColor: "#167AC3",
                                  }

                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "12px",
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                }),
                                option: (base, state) => {
                                  const isSelected = state.isSelected;
                                  const isFocused = state.isFocused;
                                  const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                  const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                  const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                  return {
                                    ...base,
                                    backgroundColor: isSelected
                                      ? selectedBg
                                      : isFocused
                                        ? hoverBg
                                        : "transparent",
                                    color: isSelected ? "#fff" : defaultTextColor,
                                    fontWeight: 600,
                                    ':active': {
                                      backgroundColor: isSelected ? selectedBg : hoverBg,
                                    },
                                  };
                                },
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,
                                }),
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={false}
                              required
                              isLoading={false}
                              isClearable={true}
                              isRtl={false}
                              isSearchable={true}
                              value={additionalChargeOptions.find(option => option.value === additionalChargeIdforExceededDistance)}
                              options={additionalChargeOptions}
                              onChange={(selectedOption) => setAdditionalChargeIdforExceededDistance(selectedOption ? selectedOption.value : '')}
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Additional Charge for Additional Driver</label>
                            <Select
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                  borderRadius: '8px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                  "&: hover": {
                                    borderColor: "#167AC3",
                                  }

                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "12px",
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                }),
                                option: (base, state) => {
                                  const isSelected = state.isSelected;
                                  const isFocused = state.isFocused;
                                  const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                  const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                  const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                  return {
                                    ...base,
                                    backgroundColor: isSelected
                                      ? selectedBg
                                      : isFocused
                                        ? hoverBg
                                        : "transparent",
                                    color: isSelected ? "#fff" : defaultTextColor,
                                    fontWeight: 600,
                                    ':active': {
                                      backgroundColor: isSelected ? selectedBg : hoverBg,
                                    },
                                  };
                                },
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,
                                }),
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isLoading={false}
                              isClearable={true}
                              required
                              isRtl={false}
                              isSearchable={true}
                              value={additionalChargeOptions.find(option => option.value === additionalChargeIdForAdditionalDriver)}
                              options={additionalChargeOptions}
                              onChange={(selectedOption) => setAdditionalChargeIdForAdditionalDriver(selectedOption ? selectedOption.value : '')}
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Additional Charge for Return In Different Location</label>
                            <Select
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                  borderRadius: '8px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                  "&: hover": {
                                    borderColor: "#167AC3",
                                  }

                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "12px",
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                }),
                                option: (base, state) => {
                                  const isSelected = state.isSelected;
                                  const isFocused = state.isFocused;
                                  const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                  const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                  const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                  return {
                                    ...base,
                                    backgroundColor: isSelected
                                      ? selectedBg
                                      : isFocused
                                        ? hoverBg
                                        : "transparent",
                                    color: isSelected ? "#fff" : defaultTextColor,
                                    fontWeight: 600,
                                    ':active': {
                                      backgroundColor: isSelected ? selectedBg : hoverBg,
                                    },
                                  };
                                },
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,
                                }),
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={false}
                              isLoading={false}
                              isClearable={true}
                              required
                              isRtl={false}
                              isSearchable={true}
                              value={additionalChargeOptions.find(option => option.value === additionalChargeIdforReturnInDifferentLocation)}
                              options={additionalChargeOptions}
                              onChange={(selectedOption) => setAdditionalChargeIdforReturnInDifferentLocation(selectedOption ? selectedOption.value : '')}
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Enable Odometer Tracking</label>
                            <RadioGroup
                              row
                              value={enableOdometerTracking}
                              onChange={(e) => setEnableOdometerTracking(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "blue",
                                    },
                                  }}
                                />} label="Yes"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "blue",
                                    },
                                  }}
                                />} label="No"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                            </RadioGroup>
                          </div>
                        </div>
                      </div>
                    }

                    <h5
                      className="mb-0 mt-4 flex items-center cursor-pointer select-none"
                      onClick={() => setIsWebsite(!isWebsite)}
                    >
                      {isWebsite ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}
                      <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                        Website
                      </div>
                    </h5>
                    <hr />

                    {isWebsite &&
                      <>
                        <div className="grid grid-cols-2 gap-6 mt-2">
                          <div className="space-y-4">
                            <div>
                              <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Similar Vehicle Make</label>
                              <input
                                type="number"
                                min={0}
                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                value={similarVehicleMakeId}
                                onChange={(e) =>
                                  setSimilarVehicleMakeId(validateMin(e.target.value, 0).toString())
                                }
                              />
                            </div>
                          </div>

                          <div className="space-y-4">
                            <div>
                              <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Similar Vehicle Model</label>
                              <input
                                type="number"
                                min={0}
                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                value={similarVehicleModelId}
                                onChange={(e) =>
                                  setSimilarVehicleModelId(validateMin(e.target.value, 0).toString())
                                }
                              />
                            </div>
                          </div>
                        </div>


                        <div style={{ marginTop: "10px" }}>
                          <label
                            htmlFor="image"
                            style={{ fontSize: "12px", fontWeight: "bold" }}
                          >
                            Website Images
                            <br />
                            <div
                              style={{
                                maxWidth: "100%",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "5px",
                                flexWrap: "wrap"
                              }}
                            >
                              {websiteFilePath.map((item: any, outerIndex: number) => {
                                return (
                                  <React.Fragment key={outerIndex}>
                                    <img
                                      src={item.fileName}
                                      width={40}
                                      height={40}
                                      alt="Vehcile Class"
                                      onClick={() => {
                                        setFileIndex(outerIndex);
                                        setWebsiteImagePopup(true);
                                      }}
                                    />
                                    <RemoveCircleIcon
                                      sx={{
                                        fontSize: "14px",
                                        color: colorConfigs.topbar.bg,
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                        "&: hover": {
                                          color: "red",
                                        },
                                      }}
                                      onClick={() => {
                                        setDeleteData({
                                          id: 0,
                                          tilte: `Delete`,
                                          summary: `Are you sure you want to delete this image?`,
                                          isDelete: (callback: any) => {
                                            setPleaseWaitPopup(true);

                                            setWebsiteFilePath(websiteFilePath.filter((_, index: number) => index !== outerIndex));
                                            setPleaseWaitPopup(false);
                                            callback();
                                          }
                                        });

                                        setDeletePopup(true);

                                        if (inputWebsiteFileRef.current) {
                                          inputWebsiteFileRef.current.value = "";
                                        }
                                      }}
                                    />
                                  </React.Fragment>
                                );
                              })}

                              <input
                                type="file"
                                accept="image/*"
                                name="inputWebsiteFileRef"
                                ref={inputWebsiteFileRef}
                                onChangeCapture={onWebsiteFileChangeCapture}
                                style={{ display: "none" }}
                              />
                            </div>

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "8px",
                                marginTop: "8px",
                              }}
                            >
                              <p
                                style={{
                                  border: "1px dashed black",
                                  borderRadius: "3px",
                                  padding: "3px 5px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  fontSize: "12px",
                                  backgroundColor: "white",
                                  cursor: "pointer"
                                }}
                                onClick={(e) => {
                                  if (inputWebsiteFileRef.current !== null) {
                                    inputWebsiteFileRef.current.value = "";

                                  }
                                  inputWebsiteFileRef.current?.click();
                                }}
                              >
                                {" "}
                                <AddIcon className="text-[#167AC3] text-[14px] font-bold" />
                                Add Image
                              </p>

                              <p
                                style={{
                                  border: "1px dashed black",
                                  borderRadius: "3px",
                                  padding: "3px 5px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  fontSize: "12px",
                                  backgroundColor: "white",
                                  cursor: "pointer"
                                }}
                                onClick={() => setWebsiteShowWebcam(true)}
                              >
                                {" "}
                                <LocalSeeIcon className="text-[#167AC3] text-[14px] font-bold" />
                              </p>
                            </div>
                          </label>
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Features</label>
                          <Select
                            menuPortalTarget={document.body}
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                backgroundColor: themeStyles.topBar.bg,
                                color: themeStyles.topBar.textColor,
                                borderRadius: '8px',
                                borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                "&: hover": {
                                  borderColor: "#167AC3",
                                }

                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999
                              }),
                              menu: (base) => ({
                                ...base,
                                fontSize: "12px",
                                backgroundColor: themeStyles.topBar.bg,
                                color: themeStyles.topBar.textColor,
                              }),
                              option: (base, state) => {
                                const isSelected = state.isSelected;
                                const isFocused = state.isFocused;
                                const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                return {
                                  ...base,
                                  backgroundColor: isSelected
                                    ? selectedBg
                                    : isFocused
                                      ? hoverBg
                                      : "transparent",
                                  color: isSelected ? "#fff" : defaultTextColor,
                                  fontWeight: 600,
                                  ':active': {
                                    backgroundColor: isSelected ? selectedBg : hoverBg,
                                  },
                                };
                              },
                              input: (base) => ({
                                ...base,
                                color: themeStyles.topBar.textColor,

                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: themeStyles.topBar.textColor,
                              }),
                            }}
                            isMulti
                            className="basic-single"
                            classNamePrefix="select"
                            isDisabled={false}
                            isLoading={false}
                            isClearable={true}
                            isRtl={false}
                            isSearchable={false}
                            name="features"
                            value={features}
                            onChange={setFeatures}
                            options={featuresOptions}
                            required
                          />
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Label</label>
                          <input
                            type="text"
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={label}
                            onChange={(e) =>
                              setLabel(e.target.value)
                            }
                            required
                          />
                        </div>

                        <div
                          className="quill-wrapper my-2"
                          style={{
                            ...(theme === 'dark' && {
                              '--quill-text-color': '#ffffff',
                              '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                            }),
                          } as React.CSSProperties}
                        >
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Short Description</label>
                          <Editor
                            editorState={editorStateShort}
                            wrapperClassName="wrapper-class"
                            editorClassName={`editor-class border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            toolbarClassName="toolbar-class"
                            onEditorStateChange={setEditorStateShort}
                            toolbar={{
                              inline: { inDropdown: false },
                              list: { inDropdown: true },
                              textAlign: { inDropdown: true },
                              link: { inDropdown: true },
                              history: { inDropdown: true },
                            }}
                          />
                        </div>

                        <div
                          className="quill-wrapper mt-8 mb-2"
                          style={{
                            ...(theme === 'dark' && {
                              '--quill-text-color': '#ffffff',
                              '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                            }),
                          } as React.CSSProperties}
                        >
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Description</label>
                          <Editor
                            editorState={editorStateDescription}
                            wrapperClassName="wrapper-class"
                            editorClassName={`editor-class border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            toolbarClassName="toolbar-class"
                            onEditorStateChange={setEditorStateDescription}
                            toolbar={{
                              inline: { inDropdown: false },
                              list: { inDropdown: true },
                              textAlign: { inDropdown: true },
                              link: { inDropdown: true },
                              history: { inDropdown: true },
                            }}
                          />
                        </div>
                      </>
                    }

                    <div className="flex gap-4 mt-6">
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.main.bg,
                          '&.Mui-disabled': {
                            backgroundColor: '#ccc',
                            color: '#666',
                          },
                        }}
                        type="submit"
                        disabled={!!minAgeError || !!maxAgeError}
                      >
                        Save
                      </Button>

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.cancel.bg,
                          border: colorConfigs.btn.cancel.border,
                          color: colorConfigs.btn.cancel.color
                        }}
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={showWebcam}
        maxWidth="md"
        fullScreen={false}
        PaperProps={{
          style: {
            marginTop: "-16%",
          },
        }}
      >
        <DialogContent sx={{ padding: "0px" }}>
          <Webcam
            width={480}
            height={320}
            ref={webRef}
            screenshotFormat="image/png"
            audio={false}
          />

          <div
            style={{
              width: "100%",
              height: "50px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              paddingBlock: "8px",
              paddingLeft: "16px",
              paddingRight: "16px",
              backgroundColor: "#eeeeee",
            }}
          >
            <div style={{ width: "50%" }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: colorConfigs.btn.cancel.bg,
                  border: colorConfigs.btn.cancel.border,
                  color: colorConfigs.btn.cancel.color
                }}
                onClick={() => setShowWebcam(false)}
              >
                Cancel
              </Button>
            </div>

            <div
              style={{
                width: "50%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: colorConfigs.topbar.bg,
                  color: "white",
                  border: "none",
                  textTransform: "capitalize",
                  fontSize: "12px",
                  "&: hover": {
                    backgroundColor: colorConfigs.topbar.bg,
                    color: "white",
                  },
                }}
                onClick={() => {
                  if (webRef.current !== null) {
                    setFile(null);
                    //@ts-ignore
                    const imageSrc = webRef.current.getScreenshot();

                    handleCapture(imageSrc, `${baseURL}vehicleClassFile/upload`, tenantId, (imageFilePath: string) => {
                      if (imageFilePath) {
                        setFile(null);
                        setFilePath(`${baseURL}vehicleClassFile/Get?name=${imageFilePath}`);
                      }
                    })

                    setShowWebcam(false);
                  }
                }}
              >
                Capture an Image
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <CustomImagePopup
        showPopup={imagePopup}
        handlePopup={() => setImagePopup(false)}
        filePath={file ? URL.createObjectURL(file[0]) : filePath}
        imageBaseUrlPath="vehicleClassFile"

      />

      <Dialog
        open={websiteShowWebcam}
        maxWidth="md"
        fullScreen={false}
        PaperProps={{
          style: {
            marginTop: "-16%",
          },
        }}
      >
        <DialogContent sx={{ padding: "0px" }}>
          <Webcam
            width={480}
            height={320}
            ref={webRef}
            screenshotFormat="image/png"
            audio={false}
          />

          <div
            style={{
              width: "100%",
              height: "50px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              paddingBlock: "8px",
              paddingLeft: "16px",
              paddingRight: "16px",
              backgroundColor: "#eeeeee",
            }}
          >
            <div style={{ width: "50%" }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: colorConfigs.btn.cancel.bg,
                  border: colorConfigs.btn.cancel.border,
                  color: colorConfigs.btn.cancel.color
                }}
                onClick={() => setWebsiteShowWebcam(false)}
              >
                Cancel
              </Button>
            </div>

            <div
              style={{
                width: "50%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: colorConfigs.topbar.bg,
                  color: "white",
                  border: "none",
                  textTransform: "capitalize",
                  fontSize: "12px",
                  "&: hover": {
                    backgroundColor: colorConfigs.topbar.bg,
                    color: "white",
                  },
                }}
                onClick={() => {
                  if (webRef.current !== null) {
                    //@ts-ignore
                    const imageSrc = webRef.current.getScreenshot();

                    handleCapture(imageSrc, `${baseURL}vehicleClassFile/upload`, tenantId, (imageFilePath: string) => {
                      if (imageFilePath) {
                        setFile(null);

                        setWebsiteFilePath(prevFilePath =>
                          [...prevFilePath, {
                            id: 0,
                            fileName: `${baseURL}vehicleClassFile/Get?name=${imageFilePath}`
                          }]
                        );
                      }
                    })

                    setWebsiteShowWebcam(false);
                  }
                }}
              >
                Capture an Image
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <CustomImagePopup
        showPopup={websiteImagePopup}
        handlePopup={() => setWebsiteImagePopup(false)}
        filePath={websiteFilePath}
        fileIndex={fileIndex}
        setFileIndex={setFileIndex}
        imageBaseUrlPath="vehicleClassFile"

      />

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  )
}
